import * as React from 'react';
import ReactDOM from 'react-dom';

interface WithTestIdProps {
  testId?: string;
}

const TEST_ID_ATTR = 'data-test-id';

/**
 * 
 * @param Component 
 * @param universalTestId Will be used if a test id is not provided in the props
 */
const withTestId = <P extends object>(Component: React.ComponentType<P>, universalTestId?: string) => {
  // doc: 9577fcd352824f9baedb4548ac08a316
  return class TestId extends React.Component<P & WithTestIdProps> {
    componentDidMount() {
      // `root` refers to the top-level DOM child and we can do a side-effect on it
      // doc: e3c869b1ec27411f8a8320af5411e655
      const root = ReactDOM.findDOMNode(this);
      this.injectTestId(root);
    }

    injectTestId = (domRoot: Element | null | Text) => {
        const { testId } = this.props;
        if (domRoot instanceof HTMLElement) {
          const test_id_attr = (testId || universalTestId || '') as string;
          domRoot?.setAttribute(TEST_ID_ATTR, test_id_attr);
        }
    }
  
    render() {
      return <Component {...this.props}/>;
    }
  };
}

export default withTestId;
